module.exports = __webpack_public_path__ + "img/info-blue.055138be.svg";